<template>
  <div class="lesson-pdf-reader">
    <div class="header">
      <div class="container">
        <button class="btn-close" @click="$emit('close')">
          <i class="fas fa-arrow-left fa-lg mr-2"></i>
        </button>
        {{ lesson.name }} - {{ resource.category }}
      </div>
    </div>

    <iframe :src="resource.file"></iframe>
  </div>
</template>

<script>
export default {
  props: {
    resource: {
      type: Object,
      default: () => ({})
    },
    lesson: {
      type: Object,
      default: () => ({})
    }
  },
  mounted() {
    document.body.classList.add("stop-scrolling");
  },
  beforeDestroy() {
    document.body.classList.remove("stop-scrolling");
  }
};
</script>

<style lang="scss" scoped>
.lesson-pdf-reader {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 99;
  background: #232020;

  .header {
    height: 64px;
    font-weight: bold;
    color: #fdfdfd;
    display: flex;
    align-items: center;
  }

  iframe {
    height: calc(100vh - 64px);
    width: 100%;
    border: none;
  }

  .btn-close {
    background: transparent;
    border: none;
    padding: 0;
    color: white;
  }
}
</style>
